export { ReactComponent as WDBLogo } from '../../assets/svg/WDB logo.svg';
export { ReactComponent as OptionIcon } from '../../assets/svg/Option icon.svg';
export { ReactComponent as DoneIcon } from '../../assets/svg/Done icon.svg';
export { ReactComponent as ArrowDarkIcon } from '../../assets/svg/Arrow.svg';
export { ReactComponent as ArrowTable } from '../../assets/svg/Arrow table.svg';
export { ReactComponent as PhoneIcon } from '../../assets/svg/Phone icon.svg';
export { ReactComponent as AddressIcon } from '../../assets/svg/Address icon.svg';
export { ReactComponent as DotsIcon } from '../../assets/svg/Dots.svg';
export { ReactComponent as Dots2Icon } from '../../assets/svg/Dots 02.svg';
export { ReactComponent as Dots3Icon } from '../../assets/svg/Dots 03.svg';
export { ReactComponent as Dots4Icon } from '../../assets/svg/Dots 04.svg';
export { ReactComponent as InsuranceIcon } from '../../assets/svg/Insurance icon.svg';
export { ReactComponent as OtionIcon } from '../../assets/svg/Option icon.svg';
export { ReactComponent as MoneyIcon } from '../../assets/svg/Money icon.svg';
export { ReactComponent as MailIcon } from '../../assets/svg/Mail icon.svg';
export { ReactComponent as ScrollUpIcon } from '../../assets/svg/Scroll up.svg';
export { ReactComponent as ContactIcon } from '../../assets/svg/Contact icon.svg';
export { ReactComponent as DocumentIcon } from '../../assets/svg/Document icon.svg';
export { ReactComponent as HomeIcon } from '../../assets/svg/Home icon.svg';
export { ReactComponent as FacebookIcon } from '../../assets/svg/Facebook icon.svg';
export { ReactComponent as LinkedinIcon } from '../../assets/svg/Linkedin icon.svg';
export { ReactComponent as InstagramIcon } from '../../assets/svg/Instagram icon.svg';
export { ReactComponent as ProcessingIcon } from '../../assets/svg/Processing icon.svg';
export { ReactComponent as CloseIcon } from '../../assets/svg/Close icon.svg';
export { ReactComponent as InfoIcon } from '../../assets/svg/Info icon.svg';
export { ReactComponent as InfoboxIcon } from '../../assets/svg/Infobox icon.svg';
export { ReactComponent as CovidIcon } from '../../assets/svg/coronavirus.svg';
// w wypełnieniu
export { ReactComponent as Mail2Icon } from '../../assets/svg/Mail icon 02.svg';
export { ReactComponent as Phone2Icon } from '../../assets/svg/Phone icon 02.svg';
export { ReactComponent as WebIcon } from '../../assets/svg/Web icon.svg';
export { ReactComponent as PostMailIcon } from '../../assets/svg/Post mail icon.svg';
